import { defineComponent as _defineComponent } from 'vue'
import { defineMessages } from '@/lib/i18n';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSearchForm',
  props: {
    keywordList: null,
    disabled: { type: Boolean }
  },
  emits: ["update:keywordList", "change"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (e: 'update:keywordList', data: string[]): void;
  (e: 'change'): void;
}), expose: any, slots: any, attrs: any }) {

const m = defineMessages({
  searchLabel:
    'SDS ID/SDSファイル名/製品名/製造者名/化学物質名/CAS番号/法令名/細則名から検索できます',
  searchHint:
    'Enterキーを押して、キーワードを確定してください。キーワードは複数入力することができます。',
});



const comboboxRef = ref();
expose({ comboboxRef });



const updateKeywordList = (e: string[]): void => {
  emits('update:keywordList', e);
};

const change = (): void => {
  emits('change');
};

return { __sfc: true,m, comboboxRef, emits, updateKeywordList, change }
}

})